import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  max-width: 1440px;
  padding-top: 70px;
  margin-left: auto;
  margin-right: auto;
  background-color: #ffffff;
  background-repeat: repeat;
  position: unset;
  display: ${(props) => (props.show ? "none" : "block")};
  height: 100vh;
`;

const WrapperContent = styled.div`
  position: relative;
  display: flex;
`;

const DivBackgroundImage = styled.div`
  width: 100%;
  height: 100%;
  margin: auto;
  display: flex;
  justify-content: center;
`;
const WrapperBackgroundImage = styled.div`
  width: 100%;
  height: 100%;
  max-height: 600px;
  position: relative;
`;

const WrapperImg = styled.div`
  width: 100%;
`;

const Img = styled.img`
  width: fit-content;
  height: 100%;
  object-fit: cover;
`;

const PageNotFound = () => {
  return (
    <Container>
      <WrapperContent>
        <WrapperImg>
          <WrapperBackgroundImage>
            <DivBackgroundImage>
              <Img src="https://xsurface-images.s3.ap-southeast-1.amazonaws.com/404X10.png" />
            </DivBackgroundImage>
          </WrapperBackgroundImage>
        </WrapperImg>
      </WrapperContent>
    </Container>
  );
};

export default PageNotFound;
